import React, { useEffect, useRef } from 'react';
import styles from './neetmocktest.module.css'
import  "./neettesthighlight.css"
import mockhighlightIcon1 from '../../assets/highlight_expert_1.svg'
import mockhighlightIcon2 from '../../assets/highlight_test_2.svg'
import mockhighlightIcon3 from '../../assets/hightlight_detailed_3.svg'
import mockhighlightIcon4 from '../../assets/hightlight_acess_4.svg'
import mockhighlightIcon5 from '../../assets/highlight_score_5.svg'
import mockhighlightIcon6 from '../../assets/highlight_skill_7.svg'

const NeetTestHighlight = () => {
    const wrapperRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const items = wrapper.querySelectorAll(".items > *");

    const handleScroll = () => {
      const scrollPosition = wrapper.scrollLeft;
      const containerCenter = wrapper.offsetWidth / 2;

      items.forEach((item) => {
        const itemCenter =
          item.offsetLeft - wrapper.offsetLeft + item.offsetWidth / 2;
        const distanceFromCenter = Math.abs(
          containerCenter - (itemCenter - scrollPosition)
        );

        // Scale and opacity effect
        const scale = Math.max(0.88, 1 - (distanceFromCenter / containerCenter) * 0.3);
        const opacity = Math.max(0.2, 1 - (distanceFromCenter / containerCenter) * 0.2);
         // Box shadow intensity (closer to center = stronger shadow)
         const shadowIntensity = Math.max(17, -4 - (distanceFromCenter / containerCenter) * 15);
         const boxShadow = `0px 8px ${shadowIntensity}px rgba(16, 24, 40, 0.25)`;
        item.style.transform = `scale(${scale})`;
        item.style.opacity = opacity;
        item.style.boxShadow = boxShadow;
      });
    };

    wrapper.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on load

    return () => wrapper.removeEventListener("scroll", handleScroll);
  }, []);
    return (
        <div>
            {/* ---------MOCK NEET TEST HIGHlight */}
            <div className={`${styles.mocktest_bg} ${styles.d_block}`}>
                <div className='container'>
                    <div className={`${styles.mocktest_heading}`}>
                        <h2>Test highlights</h2>
                    </div>
                    <div className={`${styles.mocktesthighlight_wrapper}`}>
                            {/* box1 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon2}`}>
                                    <img src={mockhighlightIcon1} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Prepared by Experts</h2>
                                    <p>Questions based on the latest NEET pattern prepared by expert Aakash Faculty</p>
                                </div>
                            </div>
                            {/* box1 */}
                            {/* box2 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon1}`}>
                                    <img src={mockhighlightIcon2} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>India's Largest Mock Test</h2>
                                    <p>Participate to compete with other aspirants at an All India Level</p>
                                </div>
                            </div>
                            {/* box2 */}
                            {/* box3 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon3}`}>
                                    <img src={mockhighlightIcon3} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Access Detailed Solutions</h2>
                                    <p>All students appearing for Aakash Mock Test to get access to detailed solutions</p>
                                </div>
                            </div>
                            {/* box3 */}
                            {/* box4 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon4}`}>
                                    <img src={mockhighlightIcon4} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Exam Simulation</h2>
                                    <p>Aakash Mock Test provides a replica of competitive exams testing experience</p>
                                </div>
                            </div>
                            {/* box4 */}
                            {/* box5 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon5}`}>
                                    <img src={mockhighlightIcon5} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Score card</h2>
                                    <p>Scorecard containing subject-wise marks and percentile score along with expected All India Rank (AIR)</p>
                                </div>
                            </div>
                            {/* box5 */}
                            {/* box6 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon6}`}>
                                    <img src={mockhighlightIcon6} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Learn Exam Skills</h2>
                                    <p>Improve crucial skills such as time management, how to attempt questions, etc</p>
                                </div>
                            </div>
                            {/* box6 */}
                    </div>
                </div>
            </div>
            {/* ---------MOCK NEET TEST HIGHlight */}
            <div className={`${styles.mocktest_bg} ${styles.m_block}`}>
                <div className='container p-0'>
                    <div className={`${styles.mocktest_heading}`}>
                        <h2>Test highlights</h2>
                    </div>
            <div className="scroll_x wrapper" ref={wrapperRef}>
            <ul className="items">
               <li>
                         {/* box1 */}
                         <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon2}`}>
                                    <img src={mockhighlightIcon1} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Prepared by Experts</h2>
                                    <p>Questions based on the latest NEET pattern prepared by expert Aakash Faculty</p>
                                </div>
                            </div>
                            {/* box1 */}
                    </li>
                    <li> {/* box2 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon1}`}>
                                    <img src={mockhighlightIcon2} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>India's Largest Mock Test</h2>
                                    <p>Participate to compete with other aspirants at an All India Level</p>
                                </div>
                            </div>
                            {/* box2 */}
                    </li>
                    <li>
                           {/* box3 */}
                           <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon3}`}>
                                    <img src={mockhighlightIcon3} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Access Detailed Solutions</h2>
                                    <p>All students appearing for Aakash Mock Test to get access to detailed solutions</p>
                                </div>
                            </div>
                            {/* box3 */}
                    </li>
                    <li>
                          {/* box4 */}
                          <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon4}`}>
                                    <img src={mockhighlightIcon4} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Exam Simulation</h2>
                                    <p>Aakash Mock Test provides a replica of competitive exams testing experience</p>
                                </div>
                            </div>
                            {/* box4 */}
                    </li>
                    <li>
                            {/* box5 */}
                            <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon5}`}>
                                    <img src={mockhighlightIcon5} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Score card</h2>
                                    <p>Scorecard containing subject-wise marks and percentile score along with expected All India Rank (AIR)</p>
                                </div>
                            </div>
                            {/* box5 */}
                    </li>
                    <li>
                          {/* box6 */}
                          <div className={`${styles.mocktesthighlight_box1}`}>
                                <div className={`${styles.mocktest_icon6}`}>
                                    <img src={mockhighlightIcon6} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>Learn Exam Skills</h2>
                                    <p>Improve crucial skills such as time management, how to attempt questions, etc</p>
                                </div>
                            </div>
                            {/* box6 */}
                    </li>
            </ul>
            </div>
            </div>
            </div>
        </div>
    )
}

export default NeetTestHighlight